import { c as _c } from "react/compiler-runtime";
import Skeleton from 'react-loading-skeleton';
import { RenderHTML } from '@shared/ui-components/render-html/render-html';
import { type MembershipRequirementBlock, type MembershipRequirementBlockLinkBlock } from '../../../../utils/data/graphql/_generated/gql-generated';
import { type MembershipRequirementsPerYear } from '../../../../utils/types/membership-requirements';
import { LinkBlock } from '../../../link-block/link-block';
import { type MembershipRequirementsBlockWithFallbacks } from '../../utils/helpers/add-fallbacks-to-membership-requirements-block';
import styles from './certifying-letters.module.scss';
type CertifyingLettersProps = {
  blockData: MembershipRequirementsBlockWithFallbacks;
  countryYearData?: MembershipRequirementsPerYear;
  isFetching: boolean;
  yearBlockData?: MembershipRequirementBlock;
};
export const CertifyingLetters = t0 => {
  const $ = _c(20);
  const {
    blockData,
    countryYearData,
    isFetching,
    yearBlockData
  } = t0;
  let t1;
  if ($[0] !== isFetching) {
    t1 = linkBlockData => {
      if (isFetching) {
        return <Skeleton className={styles["wrapper__link-skeleton"]} />;
      }
      if (!linkBlockData?.LinkToContent) {
        return;
      }
      return <LinkBlock blockData={linkBlockData} />;
    };
    $[0] = isFetching;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const renderLink = t1;
  let t2;
  if ($[2] !== blockData) {
    t2 = blockData?.CertifyingLettersAnchorLink && {
      id: blockData.CertifyingLettersAnchorLink
    };
    $[2] = blockData;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = blockData?.CertifyingLettersStepLabel;
  let t4;
  if ($[4] !== t3) {
    t4 = <h2 className={styles.wrapper__label}>{t3}</h2>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = blockData?.CertifyingLettersDescription;
  let t6;
  if ($[6] !== t5) {
    t6 = <RenderHTML html={t5} />;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== countryYearData?.unlimitedProductionNotRequired || $[9] !== renderLink || $[10] !== yearBlockData?.IncomeCertifyingLetters || $[11] !== yearBlockData?.NonCoreIncomeCertifyingLetters || $[12] !== yearBlockData?.NonCorePremiumAndCommissionCertifyingLetters || $[13] !== yearBlockData?.PremiumAndCommissionCertifyingLetters) {
    t7 = <div className={styles.wrapper__links}>{countryYearData?.unlimitedProductionNotRequired ? <>{renderLink(yearBlockData?.NonCorePremiumAndCommissionCertifyingLetters)}{renderLink(yearBlockData?.NonCoreIncomeCertifyingLetters)}</> : <>{renderLink(yearBlockData?.PremiumAndCommissionCertifyingLetters)}{renderLink(yearBlockData?.IncomeCertifyingLetters)}</>}</div>;
    $[8] = countryYearData?.unlimitedProductionNotRequired;
    $[9] = renderLink;
    $[10] = yearBlockData?.IncomeCertifyingLetters;
    $[11] = yearBlockData?.NonCoreIncomeCertifyingLetters;
    $[12] = yearBlockData?.NonCorePremiumAndCommissionCertifyingLetters;
    $[13] = yearBlockData?.PremiumAndCommissionCertifyingLetters;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t2 || $[16] !== t4 || $[17] !== t6 || $[18] !== t7) {
    t8 = <section className={styles.wrapper} {...t2}>{t4}{t6}{t7}</section>;
    $[15] = t2;
    $[16] = t4;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
};